// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Represents a version with a major, minor, build and revision component.
 */
export class Version
{
  private static readonly validationRegex = /(\d+)\.(\d+)(?:\.(\d+)(?:\.(\d+))?)?/;

  static parse(value: string): Version
  {
    const version = this.tryParse(value);
    if (!version)
      throw new Error("The specified input was not a version.");
    return version;
  }

  static tryParse(value: string): Nullable<Version>
  {
    const result = this.validationRegex.exec(value);
    if (!result)
      return null;

    const parts = result.length;
    if (parts === 3)
      return new Version(parseInt(result[1]), parseInt(result[2]));
    else if (parts === 4)
      return new Version(parseInt(result[1]), parseInt(result[2]), parseInt(result[3]));
    else if (parts === 5)
      return new Version(parseInt(result[1]), parseInt(result[2]), parseInt(result[3]), parseInt(result[4]));
    else
      throw new Error("Not supported: Invalid version regex.");
  }

  readonly major: number;
  readonly minor: number;
  readonly build: number = -1;
  readonly revision: number = -1;

  constructor(major: number, minor: number, build?: number, revision?: number)
  {
    this.major = major;
    this.minor = minor;
    if (build !== undefined)
    {
      this.build = build;
      if (revision !== undefined)
        this.revision = revision;
    }
  }

  compareTo(version: Version): number
  {
    return this.major !== version.major ? (this.major > version.major ? 1 : -1) :
      this.minor !== version.minor ? (this.minor > version.minor ? 1 : -1) :
        this.build !== version.build ? (this.build > version.build ? 1 : -1) :
          this.revision !== version.revision ? (this.revision > version.revision ? 1 : -1) :
            0;
  }

  toString(): string
  {
    if (this.build)
    {
      if (this.revision)
        return [this.major, this.minor, this.build, this.revision].join(".");
      else
        return [this.major, this.minor, this.build].join(".");
    }
    else
    {
      return [this.major, this.minor].join(".");
    }
  }
}